/**
 * 聊天服务
 * */
import dayjs from 'dayjs';
import BaseServer from '@/domain/common/base.server';
import useMsgServer from '../common/msg.server';
import useRoomBaseServer from '../room/roombase.server';
import { qa } from '@/request/index.js';
import { textToEmojiText } from '@/utils/emoji';
import { CNTz2CurTz, throttling } from '@/utils';
import recommend from '../../request/recommend';
class QaServer extends BaseServer {
  constructor() {
    if (typeof QaServer.instance === 'object') {
      return QaServer.instance;
    }
    super();
    const { interactToolStatus } = useRoomBaseServer().state;
    //消息sdk
    this.state = {
      qaList: [],
      active: false,
      recommendList: [],
    };
    this.SAMEQUEUE = [];//同问消息队列缓存
    this.listenEvents();
    this.controller = null;
    QaServer.instance = this;
    return this;
  }
  Events = {
    QA_OPEN: 'question_answer_open',
    QA_CLOSE: 'question_answer_close',
    QA_CREATE: 'question_answer_create',
    QA_COMMIT: 'question_answer_commit',
    QA_BACKOUT: 'question_answer_backout',
    QA_SET: 'question_answer_set', //设置问答名称
    QA_SAME: 'qa_like',//同问
    QA_DEL: 'qa_delete',//问答删除
    QA_RECOMMEND: 'qa_recommend',//推荐
  };
  //setSate
  setState(key, value) {
    QaServer.instance.state[key] = value;
  }
  //监听msgServer通知
  listenEvents() {
    const msgServer = useMsgServer();
    const { watchInitData, interactToolStatus } = useRoomBaseServer().state;
    msgServer.$onMsg('ROOM_MSG', msg => {
      const { role_name, third_party_user_id, join_id } = watchInitData.join_info;
      switch (msg.data.type) {
        //开启问答
        case this.Events.QA_OPEN:
          this.$emit(this.Events.QA_OPEN, msg);
          useRoomBaseServer().state.interactToolStatus.question_public_status = msg.data.question_public_status
          this.getQaHistory()
          break;
        //关闭问答
        case this.Events.QA_CLOSE:
          this.$emit(this.Events.QA_CLOSE, msg);
          break;
        //收到问答
        case this.Events.QA_CREATE:
          if (!this.state.active) return
          const { configList } = useRoomBaseServer().state;
          //主持人助理嘉宾接收全部问答，观众只接收自己问答
          const flag = role_name != 2 || (interactToolStatus.question_public_status == 1 && msg.data.join_id != join_id) || (msg.data.join_id == join_id && configList?.message_review_before_send == 1)

          if ((flag && msg.data.qa_type != 'qa_only_pass') || (!flag && msg.data.qa_type == 'qa_only_pass')) {

            msg.data.msgId = msg.data?.answer?.id || msg.data.id;
            msg.data.content = textToEmojiText(msg.data.content);
            msg.data.like_count = 0;
            msg.data.like_status = 0
            if (msg.data?.created_time) {
              // 问答创建时间由中国时区转为当地时区
              const created_time = CNTz2CurTz(msg.data.created_time)
              msg.data.created_time = created_time
              msg.data.created_at = created_time.slice(11)
            }

            this.state.qaList.push(msg.data);
          }
          this.$emit(this.Events.QA_CREATE, msg);
          break;
        //问答回复
        case this.Events.QA_COMMIT:
          if (!this.state.active) return
          //处理私信回答和公开回答
          if (
            (msg.data.join_id == join_id && msg.data.answer.is_open == '0') ||
            msg.data.answer.is_open != '0' ||
            role_name == 1
          ) {
            msg.data.content = textToEmojiText(msg.data.content);
            msg.data.msgId = msg.data?.answer?.id || msg.data.id;

            if (msg.data?.created_time) {
              // 问答创建时间由中国时区转为当地时区
              const created_time = CNTz2CurTz(msg.data.created_time)
              msg.data.created_time = created_time
              msg.data.created_at = created_time.slice(11)
            }

            if (msg.data?.answer?.created_time) {
              // 问答回复时间由中国时区转为当地时区
              const answer_time = CNTz2CurTz(msg.data.answer.created_time)
              msg.data.answer.created_time = answer_time
              msg.data.answer.created_at = answer_time.slice(11)
            }

            // 昵称加密处理
            const { clientType, watchInitData, configList } = useRoomBaseServer().state;
            const isOpenEncryption = configList['chat_nickname_encryption'] == 1;
            if (!['send', 'record', 'clientEmbed'].includes(clientType) &&
              isOpenEncryption && msg.data.join_id != watchInitData.join_info.join_id) {
              msg.data.nick_name = (msg.data.nick_name || '').substring(0, 1) + '**';
            }
            //获取原始问题的同问状态
            const curQ = this.state.qaList.find(q => {
              return q.id == msg.data.id
            })
            msg.data.like_status = curQ?.like_status || 0
            this.state.qaList.push(msg.data);
          }
          this.$emit(this.Events.QA_COMMIT, msg);
          break;
        case this.Events.QA_BACKOUT:
          if (!this.state.active) return
          const backIndex = this.state.qaList.findIndex(item => {
            return item.answer && item.answer.id == msg.data.question_answer_id;
          });
          this.state.qaList.splice(backIndex, 1);
          this.state.recommendList.some(el => {
            el.answer = el.answer.filter(ans => {
              return ans.id != msg.data.question_answer_id
            })
          })
          this.$emit(this.Events.QA_BACKOUT, msg);
          break;
        case this.Events.QA_SET:
          this.$emit(this.Events.QA_SET, msg);
          useRoomBaseServer().state.interactToolStatus.question_public_status = msg.data.question_public_status
          break;
        case this.Events.QA_SAME:
          this.SAMEQUEUE.push(msg)
          this.throttleHandleSame(msg)
          break;
        case this.Events.QA_DEL:
          const qids = msg.data.question_ids.split(',');
          const aids = msg.data.answer_ids.split(',');
          const delArrs = []
          this.state.qaList.forEach((el, index) => {
            if (qids.includes(String(el.id)) || aids.includes(String(el.answer?.id))) {
              delArrs.unshift(index)//从后往前删除不会影响索引变化
            }
          })
          delArrs.forEach(i => {
            this.state.qaList.splice(i, 1)
          })
          this.state.recommendList = this.state.recommendList.filter(el => {
            el.answer = el.answer.filter(ans => {
              return !aids.includes(String(ans.id))
            })
            return !qids.includes(String(el.id))
          })
          break;
        case this.Events.QA_RECOMMEND:
          if (msg.data.recommend_status == 1) {
            //占位，最终通过接口更新
            this.state.recommendList.push({ isMsg: true })
          } else {
            //只变更数组长度，最终通过接口更新
            this.state.recommendList.splice(this.state.recommendList.length - 1, 1)
          }
          break;
        case 'live_start':
          this.state.qaList.splice(0);
          break;
      }
    });
  }
  // 判断是不是自己发的消息
  isSelfMsg(msg) {
    const { watchInitData } = useRoomBaseServer().state;
    return msg.sender_id == watchInitData.join_info.third_party_user_id;
  }
  //判断是不是发送给当前用户的消息
  isMyMsg(msg) {
    const { watchInitData } = useRoomBaseServer().state;
    console.log(msg.data.target_id, '-', watchInitData.join_info.third_party_user_id);
    return msg.data.target_id == watchInitData.join_info.third_party_user_id;
  }
  qaEnable(params) {
    const { watchInitData } = useRoomBaseServer().state;
    return qa.list.qaEnable(Object.assign(params, { room_id: watchInitData.interact.room_id }));
  }

  qaDisable() {
    const { watchInitData } = useRoomBaseServer().state;
    return qa.list.qaDisable({ room_id: watchInitData.interact.room_id });
  }
  sendQaMsg(params) {
    const { watchInitData, configList } = useRoomBaseServer().state;
    params.room_id = watchInitData.interact.room_id;
    return qa.list.sendQaMsg(params).then((res) => {
      if (configList?.message_review_before_send != 1) {
        const { nickname, third_party_user_id, avatar, join_id } = watchInitData.join_info;
        params.content = textToEmojiText(params.content);
        this.state.qaList.push(
          Object.assign(params, {
            type: 'question',
            join_id,
            nick_name: nickname,
            account_id: third_party_user_id,
            avatar,
            msgId: res?.data?.id,
            // 不使用时间戳，而使用这种时间格式，是为了和服务端消息数据结构保持一致
            created_time: dayjs().format('YYYY-MM-DD HH:mm:ss'),
            like_count: 0,
            like_status: 0,
            id: res?.data?.id
          })
        );
        console.log('this.state.qaList', this.state.qaList);
      }
    });
  }
  //同问
  setSameQ(params) {
    const { watchInitData } = useRoomBaseServer().state;
    params.webinar_id = watchInitData.webinar.id;
    return qa.list.setSameQ(params).then((res) => {
      if (res.code == 200) {
        this.state.qaList.forEach(el => {
          if (el.id == params.question_id) {
            if (params.like_status == 1) {
              el.like_count++
              el.like_status = 1
            } else {
              el.like_count--
              el.like_status = 0
            }
          }
        })
      }
      return res

    });
  }
  // getHistoryQaMsg() {
  //   const { watchInitData } = useRoomBaseServer().state;
  //   return qa.list.getHistoryQaMsg({ room_id: watchInitData.interact.room_id });
  // }
  getCurrentPlayQuestionNum(params = {}) {
    const { watchInitData } = useRoomBaseServer().state;
    return qa.list.getCurrentPlayQuestionNum({ room_id: watchInitData.interact.room_id });
  }
  getQaHistory(params = {}) {
    const { watchInitData } = useRoomBaseServer().state;
    params.room_id = watchInitData.interact.room_id;

    // 如果是回放，需要传回放id
    if (watchInitData.webinar.type == 5 && watchInitData.switch.switch_id) {
      params.webinar_switch_id = watchInitData.switch.switch_id;
    }
    this.getQARecommendList(params)
    return qa.list.getHistoryQaMsg(params).then(res => {
      console.warn(res, '历史问答记录');
      // 昵称加密处理
      const { clientType, watchInitData, configList } = useRoomBaseServer().state;
      const isOpenEncryption = configList['chat_nickname_encryption'] == 1;
      const isSendClient = ['send', 'record', 'clientEmbed'].includes(clientType); //是否是发起端
      const list = res.data.list.map(h => {
        let nick_name = h.nick_name;
        if (!isSendClient && isOpenEncryption && h.join_id != watchInitData.join_info.join_id) {
          nick_name = (nick_name || '').substring(0, 1) + '**';
        }
        return {
          ...h,
          content: textToEmojiText(h.content),
          msgId: h?.answer?.id || h.id,
          nick_name
        };
      });
      console.log('===list:===')
      console.log('list:', list)
      this.state.qaList.splice(0, this.state.qaList.length, ...list);
    });
  }

  // [发起端] 获取已设定的问答名称
  getQaName() {
    const { watchInitData } = useRoomBaseServer().state;
    return qa.list.getQaShowName({
      webinar_id: watchInitData.webinar.id
    });
  }
  //处理同问消息
  throttleHandleSame = throttling(() => {
    const { watchInitData } = useRoomBaseServer().state;
    const { third_party_user_id } = watchInitData.join_info;
    const obj = {}
    this.SAMEQUEUE.forEach((msg) => {
      if (msg.data.account_id != third_party_user_id) {
        obj[msg.data.question_id] = msg.data?.like_count
      }
    })
    for (const key in obj) {
      if (obj.hasOwnProperty(key)) {
        for (let i = 0; i < this.state.qaList.length; i++) {
          if (this.state.qaList[i].id == key) {
            this.state.qaList[i].like_count = obj[key]
          }
        }
      }
    }
    this.SAMEQUEUE.length = 0
  }, 500)

  //获取推荐列表
  getQARecommendList(params = {}) {
    const { watchInitData } = useRoomBaseServer().state;
    params.webinar_id = watchInitData.webinar.id
    if (watchInitData.webinar.type == 5 && watchInitData.switch.switch_id) {
      params.webinar_switch_id = watchInitData.switch.switch_id;
    }
    return qa.list.getQARecommendList(params).then(res => {
      if (res.code == 200) {
        this.state.recommendList = res.data.list;
        return res.data.list
      }
    })
  }
}

export default function useQaServer() {
  return new QaServer();
}
